import { TERTIARY, makeThemeColor } from '@tornado-rdk/theme';

export const colors = {
  background: makeThemeColor(TERTIARY),
  blocks: [],
};
